import { SxProps } from '@mui/material'

import { navigationDrawerDimensions } from '../NavigationDrawer.data'

interface NavigationDrawerFooterStyles {
  container: SxProps
  signInButton: SxProps
}

export const footerStyles: NavigationDrawerFooterStyles = {
  container: {
    height: navigationDrawerDimensions.footer,
    py: 3,
    px: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    position: 'fixed',
    bottom: 0,
    width: '100%',
    borderColor: 'utils.gray200',
    borderWidth: 1,
    borderStyle: 'solid',
  },
  signInButton: {
    typography: 'textMdSemibold',
  },
}
